import { cn as a } from "../../utils/utils.js";
import p from "../../../../assets/svg/Close/Close.js";
import b from "../../../../assets/svg/DialogError/DialogError.js";
import h from "../../../../assets/svg/DialogInfo/DialogInfo.js";
import v from "../../../../assets/svg/DialogSuccess/DialogSuccess.js";
import w from "../../../../assets/svg/DialogWarning/DialogWarning.js";
import { jsx as e, jsxs as n } from "react/jsx-runtime";
import * as r from "@radix-ui/react-dialog";
var N = {
  success: {
    Icon: v,
    className: "stroke-success-700 fill-success-100"
  },
  error: {
    Icon: b,
    className: "stroke-error-600 fill-error-200"
  },
  warning: {
    Icon: w,
    className: "stroke-warn-700 fill-warn-200"
  },
  info: {
    Icon: h,
    className: "stroke-info-600 fill-info-50"
  }
};
function q({ ...o }) {
  return /* @__PURE__ */ e(r.Root, {
    "data-slot": "dialog",
    ...o
  });
}
function D({ ...o }) {
  return /* @__PURE__ */ e(r.Portal, {
    "data-slot": "dialog-portal",
    ...o
  });
}
function y({ className: o, ...t }) {
  return /* @__PURE__ */ e(r.Overlay, {
    "data-slot": "dialog-overlay",
    className: a("fixed inset-0 z-50 bg-black/50 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:animate-in data-[state=open]:fade-in-0", o),
    ...t
  });
}
function E({ id: o, className: t, classNames: l, children: i, footer: c, showCloseButton: s = !0, fullscreen: d = !0, stickyFooter: g = !1, type: m, image: f, dataTestid: u, ...x }) {
  return /* @__PURE__ */ n(D, {
    "data-slot": "dialog-portal",
    children: [/* @__PURE__ */ e(y, {}), /* @__PURE__ */ n(r.Content, {
      "data-slot": "dialog-content",
      className: a("fixed inset-x-4 top-[50%] z-50 mx-auto box-border grid w-auto max-w-[calc(100%-2rem)] translate-y-[-50%] gap-6 overflow-hidden rounded-lg bg-background shadow-lg duration-200 outline-none", "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95", "data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95", {
        success: "border-t-5 border-success-300",
        error: "border-t-5 border-error-300",
        warning: "border-t-5 border-warn-300",
        info: "border-t-5 border-info-300",
        image: "",
        none: ""
      }[m], d && "inset-0 h-full max-h-dvh w-full max-w-full translate-y-0 overflow-y-auto rounded-none sm:inset-x-6 sm:top-[50%] sm:h-fit sm:w-auto sm:max-w-lg sm:translate-y-[-50%] sm:rounded-lg", m === "image" && "overflow-hidden pt-0", t),
      ...x,
      children: [/* @__PURE__ */ n("div", {
        className: "flex h-full min-h-0 flex-col",
        "data-testid": u,
        "data-qa-ta": u,
        children: [/* @__PURE__ */ e("div", {
          className: a("flex-1 overflow-y-auto", !d && "max-h-[calc(100dvh-6rem)]"),
          children: m === "image" ? /* @__PURE__ */ n("div", {
            className: a(d ? "flex-col-custom sm:flex-row-custom flex h-full w-full" : "md:flex-row-custom flex"),
            children: [/* @__PURE__ */ e("div", {
              className: "w-full flex-1 sm:h-auto",
              children: typeof f == "string" ? /* @__PURE__ */ e("img", {
                src: f,
                alt: o,
                className: "h-full w-full object-cover sm:rounded-l-lg"
              }) : f
            }), /* @__PURE__ */ e("div", {
              className: a("flex flex-1 flex-col justify-between bg-white p-6 sm:pt-17 sm:pb-11", d && "-mt-4 sm:mt-0", l?.content),
              children: i
            })]
          }) : i
        }), g && c]
      }), s && /* @__PURE__ */ n(r.Close, {
        "data-testid": "close",
        "data-qa-ta": "close",
        "data-slot": "dialog-close",
        className: "absolute top-4 right-6 z-2 h-6 w-6 cursor-pointer border-0 bg-transparent stroke-secondary-900 stroke-[1.5] p-0 outline-0 focus-visible:outline-1 focus-visible:outline-offset-0 focus-visible:outline-secondary-900 focus-visible:outline-solid",
        children: [/* @__PURE__ */ e(p, {}), /* @__PURE__ */ e("span", {
          className: "sr-only",
          children: "Close"
        })]
      })]
    })]
  });
}
function O({ type: o = "none", showIcon: t = !0, className: l, children: i, ...c }) {
  const s = N[o];
  return /* @__PURE__ */ n("div", {
    "data-slot": "dialog-header",
    className: a("flex-col-custom box-border flex items-center gap-6 text-left", o !== "image" && "px-8 pt-11.5 pb-2 text-center", l),
    ...c,
    children: [t && s && /* @__PURE__ */ e(s.Icon, { className: a("h-10 w-10 shrink-0 stroke-[1.5]", s.className) }), /* @__PURE__ */ e("div", {
      className: a("flex-col-custom flex items-start gap-4", o !== "image" && "items-center gap-2"),
      children: i
    })]
  });
}
function F({ className: o, sticky: t, ...l }) {
  return /* @__PURE__ */ e("div", {
    "data-slot": "dialog-footer",
    className: a("flex-col-custom flex", t && "sticky bottom-0 z-10 mt-6 bg-background p-0", o),
    ...l
  });
}
function H({ className: o, type: t = "none", ...l }) {
  const i = t === "image" ? "h1" : "h3", c = "m-0 text-secondary-900", s = t === "image" ? "headline-3 font-docmorris leading-8 font-normal not-italic" : "headline-3 w-full min-w-0 leading-6 font-normal wrap-break-word lg:text-2xl lg:leading-7.5";
  return /* @__PURE__ */ e(r.Title, {
    asChild: !0,
    "data-slot": "dialog-title",
    children: /* @__PURE__ */ e(i, {
      className: a(c, s, o),
      ...l
    })
  });
}
function R({ className: o, ...t }) {
  return /* @__PURE__ */ e(r.Description, {
    "data-slot": "dialog-description",
    className: a("m-0 text-base text-secondary-900", o),
    ...t
  });
}
export {
  q as Dialog,
  E as DialogContent,
  R as DialogDescription,
  F as DialogFooter,
  O as DialogHeader,
  y as DialogOverlay,
  D as DialogPortal,
  H as DialogTitle
};

//# sourceMappingURL=dialog.js.map